/**
 * These fields are editable by the tableBooleanEditor.js
 */
export default [
  'JrStirred',
  'JrSieved',
  'MpInReports',
  'MpInExports'
]
